<div class="table-root">
  <!-- ── Tableau ── -->
  <div class="overflow-x-auto">
    <table class="ui-table">
      <thead>
        <tr class="ui-table-thead-tr">
          @for (col of columns; track $index) {
            <th [ngClass]="col.className" class="ui-table-th">
              {{ col.label }}
            </th>
          }
          <th *ngIf="actions" class="ui-table-th actions-cell">Actions</th>
        </tr>
      </thead>

      <tbody>
        <!-- État vide -->
        <tr
          *ngIf="!pagedData || pagedData.length === 0"
          class="ui-table-body-tr"
        >
          <td
            [attr.colspan]="columns.length + (actions ? 1 : 0)"
            class="ui-table-empty"
          >
            <span class="empty-icon material-icons">inbox</span>
            {{ emptyMessage }}
          </td>
        </tr>

        <!-- Lignes de données -->
        @for (row of pagedData; track $index) {
          <tr class="ui-table-body-tr">
            @for (col of columns; track colIndex; let colIndex = $index) {
              <td [ngClass]="col.className" class="ui-table-td">
                @if (col.render) {
                  <div [innerHTML]="col.render(row, $index)"></div>
                } @else if (
                  col.truncate && isTruncated(col, getCellValue(row, col))
                ) {
                  <!-- Cellule avec troncature -->
                  <div class="cell-truncate">
                    <span class="cell-text">
                      {{
                        isCellExpanded($index, colIndex)
                          ? getCellValue(row, col)
                          : getTruncatedValue(col, getCellValue(row, col))
                      }}
                    </span>
                    <button
                      class="btn-see-more"
                      (click)="toggleCell($index, colIndex)"
                    >
                      {{
                        isCellExpanded($index, colIndex)
                          ? "Réduire"
                          : "Voir plus"
                      }}
                      <span class="material-icons">
                        {{
                          isCellExpanded($index, colIndex)
                            ? "expand_less"
                            : "expand_more"
                        }}
                      </span>
                    </button>
                  </div>
                } @else {
                  {{ row[col.key || ""] }}
                }
              </td>
            }
            <td *ngIf="actions" class="ui-table-td actions-cell">
              <div class="actions-buttons">
                <ng-container
                  *ngTemplateOutlet="
                    actions;
                    context: { item: row, index: $index }
                  "
                ></ng-container>
              </div>
            </td>
          </tr>
        }
      </tbody>
    </table>
  </div>

  <!-- ── Pied de page : info + pagination ── -->
  <div class="table-footer" *ngIf="data && data.length > 0">
    <!-- Info résultats -->
    <div class="table-info">
      <span>{{ startIndex }}–{{ endIndex }}</span> sur
      <span>{{ data.length }}</span> résultats
    </div>

    <!-- Contrôles de pagination -->
    <div class="pagination">
      <!-- Sélecteur taille de page -->
      <div class="page-size-selector">
        <label>Lignes&nbsp;:</label>
        <select [value]="pageSize" (change)="onPageSizeChange($event)">
          @for (opt of pageSizeOptions; track opt) {
            <option [value]="opt">{{ opt }}</option>
          }
        </select>
      </div>

      <!-- Boutons de navigation -->
      <div class="pagination-nav">
        <!-- Précédent -->
        <button
          class="page-btn page-btn--arrow"
          [disabled]="currentPage === 1"
          (click)="goToPage(currentPage - 1)"
          aria-label="Page précédente"
        >
          <span class="material-icons">chevron_left</span>
        </button>

        <!-- Numéros de pages -->
        @for (page of pageNumbers; track $index) {
          @if (page === -1) {
            <span class="page-ellipsis">…</span>
          } @else {
            <button
              class="page-btn"
              [class.page-btn--active]="page === currentPage"
              (click)="goToPage(page)"
            >
              {{ page }}
            </button>
          }
        }

        <!-- Suivant -->
        <button
          class="page-btn page-btn--arrow"
          [disabled]="currentPage === totalPages"
          (click)="goToPage(currentPage + 1)"
          aria-label="Page suivante"
        >
          <span class="material-icons">chevron_right</span>
        </button>
      </div>
    </div>
  </div>
</div>
